export const EVENTS = {
  OPEN_SERVICE_DIALOG: "openServiceModal",
  SET_DEFAULT_API_SERVICE: "setDefaultApiService",
  OPEN_DETAIL_DIALOG: "loadCourierDetail"
};
